import { CMSLink } from '@/components/Link'
import { Media } from '@/components/Media'

import { cn } from '@/utilities/ui'
import { ChevronsRight } from 'lucide-react'
import RichText from '@/components/RichText'

const NormalCard = ({
  service,
  iconPosition = 'left',
}: {
  service: any
  iconPosition?: 'right' | 'left'
}) => {
  return (
    <div className="group transition-all ease-linear duration-300 h-full flex flex-col">
      <div className="relative block">
        <div className={cn('relative block overflow-hidden rounded-t-xl')}>
          <Media
            resource={service?.image}
            alt={service?.image?.alt || 'Service Image'}
            priority={false}
            quality={65}
            loading="lazy"
            sizes="(max-width: 390px) 292px, (max-width: 640px) 292px, (max-width: 768px) 260px, (max-width: 1024px) 278px, (max-width: 1280px) 292px, 390px"
            imgClassName={cn(
              'w-full aspect-[3/2] sm:aspect-[4/3] md:aspect-[3/2] lg:aspect-[3/2] xl:aspect-[3/2] object-cover transform scale-100 transition-transform duration-1000 ease-in-out group-hover:scale-110',
            )}
          />
          <div className="absolute top-0 bottom-0 left-1/2 right-[51%] bg-muted/30 pointer-events-none transition-all duration-[400ms] ease-linear group-hover:left-0 group-hover:right-0"></div>
        </div>
      </div>
      <div
        className={cn(
          'relative bg-card rounded-b-xl px-5 pt-3 pb-5 border border-border transition-all duration-300 ease-in-out flex-1 flex flex-col',
        )}
      >
        {service?.icon && (
          <div
            className={cn(
              'absolute top-[-40px] left-0 flex items-center justify-center w-20 h-20 bg-muted rounded-full z-[1]',
              {
                'left-[75%] ': iconPosition === 'right',
              },
            )}
          >
            <div className="absolute inset-0 rounded-full bg-primary scale-0 transition-transform duration-400 z-[-1] group-hover:scale-100 ease-out"></div>
            <span className="relative inline-block text-4xl transition-all duration-500 delay-100 scale-100">
              {' '}
              <Media resource={service?.icon} className="w-full h-full" />
            </span>
          </div>
        )}
        {/* Title */}
        {service?.title && (
          <RichText
            data={service.title}
            enableGutter={false}
            enableProse={false}
            className="text-2xl sm:text-xl md:text-2xl lg:text-3xl font-semibold mb-2 line-clamp-2 break-words text-foreground"
          />
        )}

        {/* Description */}
        {service?.description ? (
          <RichText
            data={service.description}
            enableGutter={false}
            enableProse={false}
            className="text-sm sm:text-base md:text-lg text-foreground mb-3 break-words flex-grow line-clamp-8"
          />
        ) : (
          <div className="text-sm sm:text-base md:text-lg text-foreground mb-6 break-words flex-grow line-clamp-5">
            No description available.
          </div>
        )}

        <div className="space-y-3 mt-auto">
          {service?.links?.map((item: any, linkIndex: any) => {
            const link = item.link
            return (
              <div
                key={linkIndex}
                className="relative w-fit inline-flex overflow-hidden group/link rounded-full"
              >
                <CMSLink
                  {...link}
                  key={link?.id || linkIndex}
                  className="z-10 inline-flex items-center border border-primary bg-primary text-primary-foreground hover:bg-primary/90 cursor-pointer font-semibold text-base tracking-wide transition-colors duration-300 rounded-full px-6 py-8"
                  aria-label={link.label || 'Learn more about this service'}
                >
                  <div className="w-12 h-12 rounded-full flex flex-1 items-center justify-center ml-2 bg-primary text-primary-foreground">
                    <ChevronsRight />
                  </div>
                </CMSLink>
                {/* Removed hover effect */}
              </div>
            )
          })}
        </div>
      </div>
    </div>
  )
}

export default NormalCard
